export class W3ScrollCards {
  isSwiper: boolean = false;
  isGsap: boolean = false;
  swiper: Swiper;
  slides: NodeListOf<HTMLElement>;

  constructor() {
    const scrollHistory = document.querySelector(".scroll-cards");
    if (!scrollHistory) return;
    this.slides = document.querySelectorAll(".scroll-card");
    this.setupHistory();
  }

  /**
   * Setup scroll cards history based on window.innerWidth
   */
  private setupHistory() {
    const windowWidth = window.innerWidth;

    this.isGsap = true;
    this.slides[0].classList.add("scroll-card--active");
    this.initScrollCards();
  }

  /**
   * initScrollCardsSmall() is a new method that was added to the W3ScrollCards class
   */
  initScrollCardsSmall() {}

  /**
   * Initialize scroll cards animation with GSAP
   */
  initScrollCards() {
    this.slides.forEach((item, i) => {
      item.classList.remove("swiper-slide");
    });
    this.isGsap = true;

    const stickyDiv = document.querySelector(".scroll-cards__content-left p");
    const cards = document.querySelectorAll(".scroll-card");

    function calculateStickyDivTop() {
      let stickyRect = stickyDiv.getBoundingClientRect();

      const stickyTop = stickyRect.top;
      const stickyComputedStyle = window.getComputedStyle(stickyDiv);

      //return window top if mobile
      if (window.innerWidth <= 1024) {
        return window.innerHeight / 2;
      } else {
        return window.innerHeight / 3 + 150;
      }
    }

    function checkIntersections() {
      const stickyDivTop = calculateStickyDivTop();

      let activeCard: HTMLElement | null = null;
      let activeIndex = 0;
      cards.forEach((card, index) => {
        const cardRect = card.getBoundingClientRect();

        if (
          cardRect.top <= stickyDivTop + 100 &&
          cardRect.bottom >= stickyDivTop
        ) {
          activeCard = card;
          activeIndex = index;
        }
      });

      if (activeCard) {
        cards.forEach((card, index) => {
          card.classList.remove("scroll-card--active");
          if (index < activeIndex) {
            const diff = activeIndex - index;
            card.classList.add("scroll-card--prev");

            if (diff == 1) {
              card.classList.add("scroll-card--prev");
              card.classList.remove("scroll-card--prev-2");
              card.classList.remove("scroll-card--prev-3");
            } else if (diff == 2) {
              card.classList.remove("scroll-card--prev-3");
              card.classList.add("scroll-card--prev-2");
            } else if (diff == 3) {
              card.classList.add("scroll-card--prev-3");
            } else {
              card.classList.remove("scroll-card--prev-2");
              card.classList.remove("scroll-card--prev-3");
            }
          }
          if (index > activeIndex) {
            card.classList.add("scroll-card--next");
          }
        });
        activeCard.classList.add("scroll-card--active");
        activeCard.classList.remove("scroll-card--next");
        activeCard.classList.remove("scroll-card--prev");
      }
    }

    window.addEventListener("scroll", checkIntersections);
    window.addEventListener("resize", checkIntersections);

    // Initial check in case the page is already scrolled
    checkIntersections();
  }
}
